export enum BrowserEnvironment {
  UNKNOWN_WINDOW = "UnknownWindow",
  USER_AGENT_NOT_FOUND = "UserAgentNotFound",
  CHROME = "Chrome",
  EDGE = "Edge",
  FIREFOX = "Firefox",
  SAFARI = "Safari",
  OPERA = "Opera",
  BRAVE = "Brave",
  YANDEX = "Yandex",
  VIVALDI = "Vivaldi",
  ETC = "Etc",
}

export interface BrowserEnvironmentResult {
  environment: BrowserEnvironment;
  isValid: boolean;
}

export class BrowserValidator {
  /**
   * SAT-014 웹 지원 브라우저는 Chrome, Edge
   * @returns 크롬 또는 엣지 브라우저인지 여부
   */
  static isValidBrowser(): BrowserEnvironmentResult {
    // 브라우저 환경인지 확인 (서버사이드 렌더링/Node 환경에서는 window가 정의되지 않으므로 false 반환)
    if (typeof window === "undefined") {
      return { environment: BrowserEnvironment.UNKNOWN_WINDOW, isValid: false };
    }

    // 현재 브라우저의 userAgent 문자열을 가져옴 (브라우저 종류 및 버전 정보를 포함)
    const ua = window.navigator.userAgent;

    // userAgent를 가져올 수 없는 경우(비정상적인 환경) false 반환
    if (!ua) {
      return { environment: BrowserEnvironment.USER_AGENT_NOT_FOUND, isValid: false };
    }

    // 브라우저 종류 확인
    // Edge 체크를 Chrome 체크보다 먼저 실행 (Edge의 userAgent에도 "Chrome"이 포함될 수 있음)
    // 데스크톱 Edge는 "Edg", Android Edge는 "EdgA", iOS Edge는 "EdgiOS"를 사용
    if (/Edg/.test(ua) || /EdgA/.test(ua) || /EdgiOS/.test(ua)) {
      return { environment: BrowserEnvironment.EDGE, isValid: true };
    }
    // Chrome 체크: 데스크톱/모바일 Android 크롬은 "Chrome", iOS 크롬은 "CriOS"를 사용
    if (/Chrome/.test(ua) || /CriOS/.test(ua)) {
      return { environment: BrowserEnvironment.CHROME, isValid: true };
    }
    if (/Firefox/.test(ua)) {
      return { environment: BrowserEnvironment.FIREFOX, isValid: false };
    }
    if (/Safari/.test(ua)) {
      return { environment: BrowserEnvironment.SAFARI, isValid: false };
    }
    if (/Opera/.test(ua)) {
      return { environment: BrowserEnvironment.OPERA, isValid: false };
    }
    if (/Brave/.test(ua)) {
      return { environment: BrowserEnvironment.BRAVE, isValid: false };
    }
    if (/Yandex/.test(ua)) {
      return { environment: BrowserEnvironment.YANDEX, isValid: false };
    }
    if (/Vivaldi/.test(ua)) {
      return { environment: BrowserEnvironment.VIVALDI, isValid: false };
    }

    return { environment: BrowserEnvironment.ETC, isValid: false };
  }
}
